import { Loader2Icon } from 'lucide-react'

export function LoadingSpinner() {
  return (
    <div className="flex w-full justify-center p-2">
      <Loader2Icon className="size-6 animate-spin" />
    </div>
  )
}
